// 3rd Party
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Components
import { Label } from 'common/components/Label/Label';
import { ToggleSelect } from 'common/components/ToggleSelect/ToggleSelect';
import { Div } from 'common/styles/oc-styled-components';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';
import { formatGender } from 'utils/string-utils';

import {
  selectDataInsurance,
  selectDataPatient,
} from '../../../../../connect/selectors';
import { makeSelectRequestData } from '../../../connect/selectors';

const OPTIONS = {
  FEMALE: 'Female',
  MALE: 'Male',
};

const SexAtBirthCard = () => {
  const requestData = useSelector(makeSelectRequestData);
  const patient = useSelector(selectDataPatient);
  const storedSex =
    requestData.sexAtBirth
    || formatGender(patient?.gender)?.toLowerCase()
    || undefined;
  const { layout } = useWindowDimensions();
  const [sexAtBirth, setSexAtBirth] = useState(storedSex);
  const insurance = useSelector(selectDataInsurance);

  // Add stored patient sex to requestData
  if (patient?.gender && !requestData.sexAtBirth) {
    requestData.sexAtBirth = formatGender(patient?.gender)?.toLowerCase();
  }

  const handleSexAtBirthSelect = (e) => {
    setSexAtBirth(e.target.value);
    requestData.sexAtBirth = e.target.value;
  };

  const label = (
    <Label
      label="Sex assigned at birth"
      information={(
        <>
          This information will be used by the practice for insurance purposes.
          If you'd like to share your gender, feel free to use the notes section
          on the next page.
        </>
      )}
    />
  );
  return (
    <Div
      margin={(!insurance.provider || layout === DIMENSIONS.MOBILE) && '5px 0 0'}
    >
      <ToggleSelect
        label={label}
        options={Object.values(OPTIONS)}
        value={sexAtBirth}
        onChange={handleSexAtBirthSelect}
      />
    </Div>
  );
};

export default SexAtBirthCard;
